export interface RoleRequestModel {
  name: string;
  privilegeIds: number[];
}
